
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-care",
      function () {
        return require("private-next-pages/virtual-care.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-care"])
      });
    }
  